import createVueComponent from '../createVueComponent';

const AreaChart = createVueComponent('AreaChartIcon', [
  ['path', { d: 'M3 3v18h18', key: '1s2lah' }],
  ['path', { d: 'M7 12v5h12V8l-5 5-4-4Z', key: 'zxz28u' }],
]);

export default AreaChart;
